import React from "react";
import styled from "styled-components/macro";
import { theme, Sizes } from "ui/theme";

type VerticalAlign = "top" | "center" | "bottom";
type Size = keyof Sizes;

type InlineProps = {
  children: React.ReactNode;
  /**
   * @type {VerticalAlign} Vertical alignment of child elements.
   */
  alignY?: VerticalAlign;
  /**
   * @type {Size} Space beween each child element.
   */
  space?: Size;
};

function getVerticalAlignFromEnum(alignY?: VerticalAlign) {
  switch (alignY) {
    case "top":
      return "flex-start";
    case "center":
      return "center";
    case "bottom":
      return "flex-end";
  }
}

/* TODO: Once Safari supports flex gap, enable the gap line below and
    then remove child selector and margin
    https://caniuse.com/flexbox-gap */
/* gap: ${({ $space }) => ($space ? theme[$space] : 0)}; */
const $Inline = styled.span<{ $alignY?: VerticalAlign; $space?: Size }>`
  display: inline-flex;
  align-items: ${({ $alignY }) => getVerticalAlignFromEnum($alignY)};

  & > :not(:last-child) {
    margin-right: ${({ $space }) => $space && theme[$space]};
  }
`;

/**
 * This component helps align items along a common horizontal axis.
 */
export default function Inline({ alignY, space, ...props }: InlineProps) {
  return <$Inline $alignY={alignY} $space={space} {...props} />;
}
